<div class="flex h-full w-full justify-center">
  <div class="relative h-full w-full max-w-content">
    <ng-content></ng-content>
  </div>
</div>
